import React from "react";
import styles from "./Investments.module.scss";
import CurrentRatio from "./CurrentRatio/CurrentRatio";
import { Col, Row } from "react-bootstrap";
import AssetsValue from "./AssetsValue/AssetsValue";
import InvestmentsCard from "../Dashboard/InvestmentsCard/InvestmentsCard";

const Investments = () => {
  return (
    <div className={styles.investments}>
      <Row>
        <Col md={8}>
          <AssetsValue />
        </Col>
        <Col md={4}>
          <CurrentRatio />
        </Col>
        <Col xs={12}>
          <InvestmentsCard
            className={styles.investments_card}
            headerClassName={styles.header}
            noRecordClassName={styles.no_records}
            noRecordContent={"No records were found."}
            noContentVariant="large"
          />
        </Col>
      </Row>
    </div>
  );
};

export default Investments;
